import { movies } from '@/mocks/movies';
import { tvShows } from '@/mocks/tvshows';
import { newsArticles } from '@/mocks/news';
import HeroCarousel, { type HeroSlide } from '@/pages/home/components/HeroCarousel';
import QuickCategories from '@/pages/home/components/QuickCategories';
import FeaturedSection from '@/pages/home/components/FeaturedSection';
import NewsSection from '@/pages/home/components/NewsSection';
import SiteIntro from '@/pages/home/components/SiteIntro';

export default function Home() {
  const heroSlides: HeroSlide[] = [
    ...movies.filter((item) => item.featured),
    ...tvShows.filter((item) => item.featured),
  ].map((item) => ({
    id: item.id,
    title: item.title,
    year: item.year,
    rating: item.rating,
    genres: item.genres,
    region: item.region,
    backdrop: item.backdrop,
    synopsis: item.synopsis,
    type: item.type,
  }));

  const moviePicks = [...movies].sort((a, b) => b.rating - a.rating).slice(0, 6);
  const tvPicks = [...tvShows].sort((a, b) => b.popularity - a.popularity).slice(0, 6);
  const latestNews = [...newsArticles]
    .sort((a, b) => (a.publishTime < b.publishTime ? 1 : -1))
    .slice(0, 5);

  return (
    <div className="w-full">
      <HeroCarousel slides={heroSlides} />

      <QuickCategories />

      <div className="w-full py-12 md:py-16 space-y-12 md:space-y-16">
        <FeaturedSection
          title="电影精选"
          subtitle="近期口碑与热度双高的院线佳片"
          moreLink="/movie"
          items={moviePicks}
        />

        <div className="w-full bg-background-100 py-12 md:py-16">
          <FeaturedSection
            title="电视剧精选"
            subtitle="正在热播与高口碑完结剧集"
            moreLink="/tv"
            items={tvPicks}
          />
        </div>

        <NewsSection articles={latestNews} />
      </div>

      <SiteIntro />
    </div>
  );
}